import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Select, {SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import Tooltip from '@mui/material/Tooltip';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { getShortDateDisplayStr, getRelativeShortDisplay } from '../../util/datetime';
import { TimedObject } from '../../util/types';
import {
  Ticket,
  TicketEditRequest,
  selectTicket,
  selectChildrenItems,
  toEditRequest,
} from './ticketSlice';
import { useTicketViewQuery, TicketItemsResponse } from '../../api/ticket';

interface QueryProps {
	tod: TimedObject | null;
	onChange: (value: string | null) => void;
};

const options = [
	{id: '', name: 'None'},
	{id: '1', name: 'Area'},
	{id: '2', name: 'Goal'},
	{id: '3', name: 'Project'},
	{id: '4', name: 'Epic'},
	{id: '5', name: 'Deliverable'},
	{id: '6', name: 'Task'},
];

export default function TimeObjectDisplay({tod, onChange}: QueryProps) {
	const [value, setValue] = React.useState<TimedObject | null>(tod);
	const handleChange = (event: SelectChangeEvent) => {
	};
	let start = tod ? getShortDateDisplayStr(tod.start) : "";
	const startLong = tod && tod.start ? new Date(tod.start).toString() : "";
	let end = tod ? getShortDateDisplayStr(tod.end) : "";
	const endLong = tod && tod.end ? new Date(tod.end).toString() : "";
	let plannedStart = tod ? getShortDateDisplayStr(tod.planned_start) : "";
	let plannedEnd = tod ? getShortDateDisplayStr(tod.planned_end) : "";
	const plannedStartLong = tod && tod.planned_start ? new Date(tod.planned_start).toString() : "";
	const plannedEndLong = tod && tod.planned_end ? new Date(tod.planned_end).toString() : "";
	let deadline = tod ? getShortDateDisplayStr(tod.deadline) : "";
	//let estimate = tod ? getShortDateDisplayStr(tod.estimate) : "";

	return (
		<Box>
			<Typography display="inline" variant="caption" >Start:</Typography>
			<Tooltip title={startLong}>
			<Typography display="inline" variant="body2">
			<>{start}</>
			</Typography>
			</Tooltip><br />
			<Typography display="inline" variant="caption">End:</Typography>
			<Tooltip title={endLong}>
			<Typography display="inline" variant="body2">{end}</Typography>
			</Tooltip><br />
			<Typography display="inline" variant="caption">Planned Start:</Typography>
			<Tooltip title={plannedStartLong}>
			<Typography display="inline" variant="body2">{plannedStart}</Typography>
			</Tooltip><br />
			<Typography display="inline" variant="caption">Planned End:</Typography>
			<Tooltip title={plannedEndLong}>
			<Typography display="inline" variant="body2">{plannedEnd}</Typography>
			</Tooltip><br />
			<Typography display="inline" variant="caption">Deadline:</Typography>
			<Typography display="inline" variant="body2">{deadline}</Typography>
		</Box>
	);
}
